<app-guest-auth-main-layout>
  <ng-template>
    <div class="otp-container bg-white px-5 py-4 rounded-md shadow-lg max-w-md w-full mx-auto">
      <h2 class="!text-lg !text-primary-500 !font-bold mb-2">{{ "Verify OTP" | concat|translate }}</h2>

      <p class="text-sm text-gray-700 mb-1">{{"The OTP has been sent to " | concat|translate }}:</p>

      <div class="flex items-center gap-2 mb-4">
        <input *ngIf="isEditing"
               [(ngModel)]="phoneOrEmail"
               class="border border-gray-300 p-2 rounded-md w-full"
               placeholder='{{"Enter phone or email"| concat|translate}}'/>
        <span *ngIf="!isEditing" class="font-bold text-gray-800">{{ phoneOrEmail }}</span>
        <button type="button"
                class="text-sm text-blue-500 underline"
                (click)="toggleEdit()">
          {{ (isEditing ? 'Save' : 'Edit')| concat|translate }}
        </button>
      </div>

      <p *ngIf="!isTimerExpired" class="text-sm text-gray-600 mb-2">
        {{ "Time remaining "| concat|translate }}: <strong>{{ formattedTime }}</strong>
      </p>
      <p *ngIf="isTimerExpired" class="text-sm text-red-600 font-semibold mb-2">
        {{ "OTP has expired. Please request a new one"| concat|translate }}
      </p>

      <form [formGroup]="otpForm" (ngSubmit)="verifyOtp()">
        <div class="otp-inputs flex gap-2 justify-center mb-4">
          <input
            type="text"
            maxlength="1"
            *ngFor="let control of otpControls; let i = index"
            [formControlName]="i"
            (input)="onInput($event, i)"
            class="w-10 h-10 text-center border border-gray-300 rounded-md text-lg"
          />
        </div>

        <div class="flex flex-wrap justify-center gap-3">
          <button type="submit"
                  mat-raised-button
                  class="!bg-primary-500 !text-white px-4 py-2 rounded-md"
                  [disabled]="!otpForm.valid">
            {{ "Verify"| concat|translate }}
          </button>

          <button mat-raised-button
                  *ngIf="isTimerExpired"
                  class="!bg-yellow-500 !text-white px-4 py-2 rounded-md"
                  (click)="resetTimer()">
            {{ " Resend OTP"| concat|translate }}
          </button>

          <button type="button"
                  mat-raised-button
                  class="!bg-red-500 !text-white px-4 py-2 rounded-md"
                  (click)="cancel()">
            {{ "Cancel "| concat|translate }}
          </button>
        </div>
      </form>

      <p *ngIf="errorMessage" class="text-red-600 mt-2">{{ errorMessage| concat|translate }} </p>
    </div>

  </ng-template>
</app-guest-auth-main-layout>
